export default {
  type: "FieldType",
  label: "Configure the values for the field type", //if included will control the groups
  groups: [
    {
      id: "config",
      label: "Configuration",
      description: "Basic configuration for the field.",
      expanded: true,
    },
    {
      id: "properties",
      label: "Properties",
      description: "Additional properties for the field.",
    },
    {
      id: "render",
      label: "Render",
      description: "Render properties for the field.",
    },
  ],
  fields: [
    {
      id: "id",
      label: "ID",
      type: "Text",
      required: true,
      unique: true,
      description: "The unique id of the field.",
      group: "config",
    },
    {
      id: "type",
      label: "Type",
      type: "Text", // You can render this as a dropdown for field types like Text, Boolean, etc.
      options: [
        "Text",
        "Boolean",
        "Image",
        "Object",
        "Content",
        "Array",
        "File",
        "Video",
        "Audio",
        "Number",
        "DatabaseModel",
      ],
      required: true,
      description: "The type of the field (e.g., Text, Boolean, Image, etc.).",
      group: "config",
    },
    {
      id: "label",
      label: "Label",
      type: "Text",
      description: "The display label of the field.",
      placeholder: "Add a type label...",
      group: "config",
    },
    {
      id: "item",
      label: "Item Type",
      type: "Text",
      description: "What type of Content is this field?",
      multiple: false,
      required: true,
      // The options are resolved based on the field type
      options: [
        {
          resolver: "{{DatabaseModelTypeResolver.availableTypeNames}}",
          type: { in: ["DatabaseModel"] },
        },
        {
          resolver: "{{TypeResolver.availableTypeNames}}",
          type: { in: ["Array", "Content"] },
        },
      ],
      visibleIf: {
        type: { in: ["Array", "Content", "DatabaseModel"] },
      },
      group: "config",
    },
    {
      id: "group",
      type: "Text",
      label: "Group",
      options: "{{ContentType.fieldGroups}}",
      description: "Add this field to a group for better organization.",
      group: "config",
    },
    {
      id: "allowDuplicateSelection",
      label: "Allow Duplicate Values",
      type: "Boolean",
      description: "Controls if the same values can be entered multiple times in the array.",
      default: false,
      group: "properties",
      visibleIf: {
        type: { in: ["Array"] },
      },
    },

    {
      id: "description",
      label: "Description",
      type: "Text",
      description:
        "Add meaningful description for the field. Shown upon creation of content.",
      default: "",
      multiline: true,
      group: "properties",
    },
    {
      id: "localization",
      label: "Localization",
      type: "Boolean",
      description:
        "Specify if the field should change between different languages.",
      default: false,
      group: "properties",
      visibleIf: {
        type: { in: ["Text", "Video", "Image", "Audio", "Object"] },
      },
    },
    {
      id: "required",
      label: "Required",
      type: "Boolean",
      description: "Indicates if the field is required.",
      group: "properties",
    },
    {
      id: "readOnly",
      label: "Read Only",
      type: "Boolean",
      description: "Indicates if the field is read-only.",
      group: "properties",
      default: false,
    },
    {
      id: "instance",
      label: "Value per Instance",
      type: "Boolean",
      description:
        "If enabled, the field value will be saved with the content instance.",
      default: false,
      group: "properties",
    },
    {
      id: "formats",
      label: "Formats",
      type: "Text",
      multiple: true,
      description: "Accepted file formats (e.g., png, jpg).",
      default: "",
      group: "properties",
      visibleIf: {
        type: { in: ["Image", "File", "Video", "Audio"] },
      },
    },
    {
      id: "fieldEditor",
      label: "Field Editor",
      type: "Text",
      options: ["Default", "HtmlEditor", "DateEditor", "DateRangeEditor", "AldooLayoutEditor", "ColorPickerEditor", "StoreExtensionsEditor", "StoreOptionValuesEditor", "SizeChartGridEditor", "SizeChartSelect"],
      default: "Default",
      description:
        "Define an Editor when you want to change data on this field.",
      group: "properties",
      visibleIf: {
        type: { in: ["Text", "Content"] },
      },
    },
    {
      id: "maxFileSize",
      label: "Max File Size ( MB )",
      type: "Number",
      description: "Maximum file size allowed for file uploads.",
      default: "",
      group: "properties",
      visibleIf: {
        type: { in: ["Image", "File", "Video", "Audio"] },
      },
    },
    {
      id: "multiline",
      label: "Multiline",
      type: "Boolean",
      description:
        "Specifies if the input should support multiple lines (textarea).",
      default: false,
      group: "properties",
      visibleIf: {
        type: { in: ["Text"] },
      },
    },

    {
      id: "options",
      label: "Options",
      type: "Text",
      multiple: true,
      description:
        "Add the possible options for the field. Shown as a dropdown.",
      default: [],
      group: "properties",
      visibleIf: {
        type: { in: ["Text"] },
      },
    },
    {
      id: "default",
      label: "Default Value",
      type: "Text",
      description: "The default value for this field.",
      default: "",
      group: "properties",
      visibleIf: {
        type: { nin: ["Image", "File", "Video", "Audio", "Array", "Object"] },
      },
    },
    {
      id: "multiple",
      label: "Multiple",
      type: "Boolean",
      description: "Allows multiple values for this field.",
      default: false,
      group: "properties",
      visibleIf: {
        type: { nin: ["Boolean", "Array", "Object"] },
      },
    },
    {
      id: "allowDuplicateSelection",
      label: "Allow Duplicate Values",
      type: "Boolean",
      description: "Controls if the same values can be entered multiple times when Multiple is enabled.",
      default: false,
      group: "properties",
      visibleIf: {
        type: { in: ["Text"] },
        multiple: true,
      },
    },
    {
      id: "render",
      label: "Render",
      type: "Object",
      multiple: false,
      group: "render",
    },
  ],
}
